import { render, staticRenderFns } from "./IadeYonetimi.vue?vue&type=template&id=61f135e6"
import script from "./IadeYonetimi.vue?vue&type=script&lang=js"
export * from "./IadeYonetimi.vue?vue&type=script&lang=js"
import style0 from "./IadeYonetimi.vue?vue&type=style&index=0&id=61f135e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports